module.exports = __webpack_public_path__ + "img/banner3_1.f3f8f077.png";